export const site = {
  name: '蝌蚪吃瓜',
  slogan: '一条时间线，吃透一个瓜',
  intro:
    '蝌蚪吃瓜把散落在热搜、长文与短视频里的娱乐事件，重新按时间排成一条线。我们从事件起点开始记录，标出每一个发酵节点，直到事情有了阶段性结局，让来龙去脉和前因后果一眼看清。',
  email: 'hello@kedou-chigua.example.com',
  cooperateEmail: 'press@kedou-chigua.example.com',
  updateTime: '2026-09-10',
  stats: [
    { label: '已梳理事件', value: '560+' },
    { label: '时间线节点', value: '1.8 万' },
    { label: '平均阅读', value: '3 分钟' },
    { label: '每周更新', value: '21 篇' },
  ],
  principles: [
    {
      icon: 'ri-time-line',
      title: '先排时间，再下判断',
      desc: '所有内容先按发生先后排序，确认时间关系之后才讨论因果，避免把顺序讲反。',
    },
    {
      icon: 'ri-link-m',
      title: '注明来源与分歧',
      desc: '每条节点标注信息出现的时间与出处，有争议的说法单独列出，不和已确认的内容混在一起。',
    },
    {
      icon: 'ri-refresh-line',
      title: '持续更新与修正',
      desc: '事件还在发展就持续追加节点，发现错误就修订并保留说明，让时间线始终跟得上。',
    },
  ],
};